
import { Box, Divider, useTheme, Grid, Typography, TextField, Button, Autocomplete, RadioGroup, FormControlLabel, Radio, Tooltip, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";



import ReceiptRoundedIcon from '@mui/icons-material/TransferWithinAStation';
import CustomAutocomplete from "../../components/commonautocomplete";

import { format } from 'date-fns';
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";


const LoadBinStorageDetails = ({ handleCallBack, stackingID, ReelID, locationCode, levelValue, bin_id, selectedBinStatus }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [reelList, setReelList] = useState([]);
    const [selectedReel, setSelectedReel] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // reel details
    const [reelIdenfification, setReelIdentification] = useState(0);
    const [weight, setWeight] = useState(0);
    const [size, setSize] = useState('');
    const [quality, setQuality] = useState('');
    const [gsm, setGSM] = useState('');

    const [selectedProductType, setSelectedProductType] = useState('bundle');
    const [selectedButton, setSelectedButton] = useState('');

    const [transferStock, setTransferStock] = useState(false);
    const [slotList, setSlotList] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);

    const [paymentTerms, setPaymentTerms] = useState([]);
    const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
    const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
    const [paymentTermsID, setPaymentTermsID] = useState(0);
    const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);
    // API CALL WARE    HOUSE LIST
    const [isDataLoaded1, setIsDataLoaded1] = useState(false);


    useEffect(() => {
        const loadData = async () => {
            if (selectedBinStatus === "stored") {
                const para = {
                    p_companyid: 1,
                    p_id_rack_bin: bin_id
                };

                try {
                    const data = await callApi(API_ENDPOINTS.WAREHOUSE_GET_BIN_PRODUCT_CODE_AND_TYPE, 'POST', { 'Content-Type': 'application/json' }, para);

                    if (data && data.length > 0) {
                        setSelectedProductType(data[0].product_type);
                        await callLoadProductCode(data[0].product_type, data[0].product_id);
                    } else {
                        setReelList([]);
                    }
                } catch (error) {
                    console.error('Error loading data:', error);
                }
            }

        };

        loadData();
    }, [selectedBinStatus]); // Dependency array


    const callLoadProductCode = async (productType, product_id) => {
        setSelectedProductType(productType);
        let product_mode = 2;

        if (productType === 'pallet') {
            product_mode = 1;
        }
        else if (productType === 'reampallet') {
            product_mode = 3;
        }

        const para = {
            p_companyid: 1,
            p_product_type: product_mode,
            p_storage_status: 'stored'
        }

        const data = await callApi(API_ENDPOINTS.WAREHOUSE_GET_BIN_PRODUCT_CODE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        if (data && data.length > 0) {
            setReelList(data);

            // set selected value 
            const selectedvalue = data.find((item) => item.id === product_id);
            if (selectedvalue) {
                setSelectedReel(selectedvalue);
                setReelIdentification(selectedvalue.id);
                const detailPara = { p_companyid: 1, p_product_type: product_mode, p_product_id: selectedvalue.id }
                const detail = await callApi(API_ENDPOINTS.WAREHOUSE_GET_SELECTED_PRODUCT_DETAILS, 'POST', { 'Content-Type': 'application/json' }, detailPara);

                if (detail && detail.length > 0) {
                    setSize(detail[0].product_size);
                    setWeight(detail[0].product_weight);
                    setQuality(detail[0].item_code);
                    setGSM(detail[0].gsm);
                }

            }

        }
        else {
            setReelList([]);
        }

    };



    const handleProductTypeChange = (event) => {
        setSelectedProductType(event.target.value);
        let product_mode = 2;

        if (event.target.value === 'pallet') {
            product_mode = 1;
        }
        else if (event.target.value === 'reampallet') {
            product_mode = 3;
        }

        const para = {
            p_companyid: 1,
            p_product_type: product_mode,
            p_storage_status: 'open'
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_BIN_PRODUCT_CODE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setReelList(data);
                }
                else {
                    setReelList([]);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };

    useEffect(() => {

        if (selectedProductType != "") {


            let product_mode = 2;

            if (selectedProductType === 'pallet') {
                product_mode = 1;
            }
            else if (selectedProductType === 'reampallet') {
                product_mode = 3;
            }

            const para = {
                p_companyid: 1,
                p_product_type: product_mode,
                p_storage_status: 'open'
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_BIN_PRODUCT_CODE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setReelList(data);
                    }
                    else {
                        setReelList([]);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    });


    const callback = () => {
        handleCallBack();
    }

    useEffect(() => {

        if (!isDataLoaded || selectedProductType === 'bundle') {



            const para = {
                p_companyid: 1,
                p_product_type: 2
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_BIN_PRODUCT_CODE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setReelList(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleGetReelDetails = (ReelID) => {

        if (ReelID != 'undefined' && ReelID != null) {
            setReelIdentification(ReelID);

            let product_mode = 2;

            if (selectedProductType === 'pallet') {
                product_mode = 1;
            }
            else if (selectedProductType === 'reampallet') {
                product_mode = 3;
            }


            const para = { p_companyid: 1, p_product_type: product_mode, p_product_id: ReelID }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_SELECTED_PRODUCT_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        // setPONumber(data);
                        setSize(data[0].product_size);
                        setWeight(data[0].product_weight);
                        setQuality(data[0].item_code);
                        setGSM(data[0].gsm);

                    }
                })
                .catch(error => {
                    // callMessage('error', error.message, 'Error');
                });
        }
    }

    const handleClearReelDetails = () => {
        setSize('');
        setWeight('');
        setQuality('');
        setGSM('');

    }

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setTransferStock(true);


    };

    const handleOpenMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    const handleCloseMenu = (setter) => () => {
        setter(null);
    };

    const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
        setSelectedOption(option);
        setSelectedID(option ? option.id : null);
        handleCloseMenu();

        const para = {
            p_companyid: 1,
            p_id_warehouse: option.id,
            p_mode: 1,
        }
        callApi(API_ENDPOINTS.WAREHOUSE_GET_AVAILABLE_SLOT_FOR_BINS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSlotList(data);
                }
                else {
                    setSlotList([]);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };

    const handleAddOption = (label) => () => {
        if (label == 'Warehouse') {
            setPaymentTermDialogOpen(true);
        }
    };


    useEffect(() => {
        if (!isDataLoaded1) {

            const para = {
                p_companyid: 1,
                p_storage_mode: 2,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPaymentTerms(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded1]);


    const StoreReelToWarehouse = () => {

        if (size === '') {
            alert('Kindly select product code to store ');
            return
        }
        // Validation: Check if any required parameter is null or undefined
        const requiredParameters = [
            { name: 'Location Code', value: locationCode },
            { name: 'Product Code', value: reelIdenfification },
            { name: 'Bin Value', value: bin_id },
            // { name: 'Sub Zone Code', value: subZone },
            // { name: 'Stacking ID', value: stackingID },

        ];

        const missingParameter = requiredParameters.find(param => param.value === null || param.value === undefined || param.value === '');

        if (missingParameter) {
            alert(`Please provide a valid value for ${missingParameter.name}.`);
            return;
        }

        let product_mode = 2;

        if (selectedProductType === 'pallet') {
            product_mode = 1;
        }
        else if (selectedProductType === 'reampallet') {
            product_mode = 3;
        }

        const parameter = {
            p_companyid: 1,
            p_product_type: product_mode,
            p_product_id: reelIdenfification,
            p_id_rack_bin: bin_id
        }

        callApi(API_ENDPOINTS.WAREHOUSE_INSERT_BIN_STORAGE_PRODUCT_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {

                    if (product_mode === 2) {
                        GetAndUpdateStoredProductDetails(reelIdenfification, data[0].location_id, locationCode);
                    } else if (product_mode === 3) {
                        GetAndUpdateStoredProductDetailsReamPallet(reelIdenfification, data[0].location_id, locationCode);
                    } else if (product_mode === 1) {
                        GetAndUpdateStoredProductDetailsBulkPallet(reelIdenfification, data[0].location_id, locationCode);
                    }


                }
            })
            .catch(error => {
                alert(error.message);
            });
    };


    const callTransferData = async () => {
        if (selectedLocation.id_rack_bins > 0) {
            const parameters = {
                p_companyid: 1,
                p_id_rack_bin: bin_id,
                p_new_id_rack_bin: selectedLocation.id_rack_bins
            };

            const data = await callApi(API_ENDPOINTS.WAREHOUSE_TRANSFER_BIN_PRODUCT, 'POST', { 'Content-Type': 'application/json' }, parameters);
            if (data && data.length > 0) {

                alert('Product Transfered from Warehouse Location:' + locationCode + ' to ' + selectedLocation.location_code + ' Successfully');
                callback();
            }
            else {

            }
        }
        else {
            alert("Please select new transfer location");
        }


    };

    const [bundleDetails, setBundleDetails] = useState();

    // product details
    const GetAndUpdateStoredProductDetails = async (reelIdenfification, location_id, locationCode) => {

        const orderData = {
            p_companyid: 1,
            p_bundle_number: '',
            p_mode: 1,
            p_pallet_id: reelIdenfification,
        };
        await callApi(API_ENDPOINTS.FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_bundle, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    const today = format(new Date(), 'yyyy-MMM-dd');
                    let localFinishedGoodsReelBundleList = [
                        {
                            ReelBundleNumber: data[0].bundle_number,
                            ReelBundleWeight: parseFloat(data[0].bundle_weight), // Keep it as a number //reel , bundle weight
                            ProductId: parseInt(data[0].product_id)
                        }
                    ];

                    const requestBody = {
                        ProductID: data[0].product_id,
                        StockLedgerID: 0,
                        AllocatedOrderId: data[0].confirmation_id,
                        AllocatedOrderNo: data[0].indent_no,
                        LocationId: location_id,
                        UOM: 'Kg',
                        PackageMode: 'Bundle', //bundle
                        NoOfSheets: data[0].sheets_in_reams, //need from production from per ream
                        ReamWeight: data[0].ream_weight, //need from production
                        PacketsPerBundle: data[0].no_of_reams, //no of reams per bundle production
                        NoOfBundles: 1,
                        ReelOD: 0,
                        CoreID: 0,
                        NoOfReels: 0, //0
                        LotNo: data[0].lot_no,
                        ProducedQty: 0,
                        ProductionDate: today,
                        Remarks: '',
                        TransactionType: 'ManufacturedOrderItemIn',
                        FinishedGoodsReelBundleList: localFinishedGoodsReelBundleList,
                        filter: {
                            COMPANY_FINANCIAL_YEAR_ID: 1,
                            COMPANY_ID: 1,
                        },
                    };

                    callApi(API_ENDPOINTS.updateProductionQtyToInventory, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                        .then(data => {
                            if (data && data.length > 0) {
                                alert('Product Stored in Warehouse Location:' + locationCode + ' Successfully');
                                callback();
                            }
                        })
                        .catch(error => {
                            throw error;
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });

    }

    // product details
    const GetAndUpdateStoredProductDetailsReamPallet = async (reelIdenfification, location_id, locationCode) => {

        const orderData = {
            p_companyid: 1,
            p_bundle_number: '',
            p_mode: 0,
            p_pallet_id: reelIdenfification,
        };
        await callApi(API_ENDPOINTS.FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_Ream_Pallet, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                
                    const today = format(new Date(), 'yyyy-MMM-dd');
                    let localFinishedGoodsReelBundleList = [
                        {
                            ReelBundleNumber: data[0].ream_pallet_number,
                            ReelBundleWeight: parseFloat(data[0].ream_pallet_weight), // Keep it as a number //reel , bundle weight
                            ProductId: parseInt(data[0].product_id)
                        }
                    ];

                    const requestBody = {
                        ProductID: data[0].product_id,
                        StockLedgerID: 0,
                        AllocatedOrderId: data[0].confirmation_id,
                        AllocatedOrderNo: data[0].indent_no,
                        LocationId: location_id,
                        UOM: 'Kg',
                        PackageMode: 'Bundle', //bundle
                        NoOfSheets: data[0].sheets_in_reams, //need from production from per ream
                        ReamWeight: data[0].ream_weight, //need from production
                        PacketsPerBundle: data[0].no_of_reams, //no of reams per bundle production
                        NoOfBundles: 1,
                        ReelOD: 0,
                        CoreID: 0,
                        NoOfReels: 0, //0
                        LotNo: data[0].lot_no,
                        ProducedQty: 0,
                        ProductionDate: today,
                        Remarks: '',
                        TransactionType: 'ManufacturedOrderItemIn',
                        FinishedGoodsReelBundleList: localFinishedGoodsReelBundleList,
                        filter: {
                            COMPANY_FINANCIAL_YEAR_ID: 1,
                            COMPANY_ID: 1,
                        },
                    };

                    callApi(API_ENDPOINTS.updateProductionQtyToInventory, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                        .then(data => {
                            if (data && data.length > 0) {
                                alert('Product Stored in Warehouse Location:' + locationCode + ' Successfully');
                                callback();
                            }
                        })
                        .catch(error => {
                            throw error;
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });

    }

    const GetAndUpdateStoredProductDetailsBulkPallet = async (reelIdenfification, location_id, locationCode) => {
        const orderData = {
            p_companyid: 1,
            p_pallet_number: reelIdenfification,
            p_mode: 0,
            p_child_reel_number: '',
            p_sheeter_hdr_id: reelIdenfification
        };

        await callApi(API_ENDPOINTS.FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_Pallet, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    //const today = new Date().toLocaleDateString().format('YYYY-MMM-DD');
                    const today = format(new Date(), 'yyyy-MMM-dd');
                    //const formattedDate = dayjs(selectedDate).format('YYYY-MMM-DD');
                    let localFinishedGoodsReelBundleList = [
                        {
                            ReelBundleNumber: data[0].pallet_code,
                            ReelBundleWeight: parseFloat(data[0].pallet_weight), // Keep it as a number //reel , bundle weight
                            ProductId: parseInt(data[0].product_id)
                        }
                    ];

                    const requestBody = {
                        ProductID: data[0].product_id,
                        StockLedgerID: 0,
                        AllocatedOrderId: data[0].confirmation_id,
                        AllocatedOrderNo: data[0].indent_no,
                        LocationId: location_id,
                        UOM: 'Kg',
                        PackageMode: 'Bundle', //bundle
                        NoOfSheets: data[0].no_of_sheets, //need from production from per ream
                        ReamWeight: 0, //need from production
                        PacketsPerBundle: 0, //no of reams per bundle production
                        NoOfBundles: 1,
                        ReelOD: 0,
                        CoreID: 0,
                        NoOfReels: 0, //0
                        LotNo: data[0].lot_no,
                        ProducedQty: 0,
                        ProductionDate: today,
                        Remarks: '',
                        TransactionType: 'ManufacturedOrderItemIn',
                        FinishedGoodsReelBundleList: localFinishedGoodsReelBundleList,
                        filter: {
                            COMPANY_FINANCIAL_YEAR_ID: 1,
                            COMPANY_ID: 1,
                        },
                    };

                    callApi(API_ENDPOINTS.updateProductionQtyToInventory, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                        .then(data => {
                            if (data && data.length > 0) {
                                alert('Product Stored in Warehouse Location:' + locationCode + ' Successfully');
                                callback();
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });

    }
    return (
        <Box>
            {transferStock === false && (
                <>
                    <Header title={selectedBinStatus === 'stored' ? 'Edit Bin Allocation' : 'Bin Allocation for Bundles & Pallets'} subtitle="" callback={callback} />
                    <Divider />
                    {selectedBinStatus === 'stored' && (
                        <>
                            <Grid container display="flex-start" padding={0}>
                                <Grid item md={0} ml="5px" mr="5px">
                                    <Tooltip title="Add new orders">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleButtonClick('StackingReels')}>
                                                <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'StackingReels' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Transfer Location</Typography>
                                            </IconButton>

                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                            </Grid>

                            <Divider />
                        </>
                    )}


                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        <Grid container  >
                            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontWeight="bold"> Location Code </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            size="small"
                                            // label="Zone"
                                            variant="outlined"
                                            value={locationCode}
                                            // onChange={(e) => setZone(e.target.value)}
                                            required
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontWeight="bold"> Product Type </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <RadioGroup row value={selectedProductType} onChange={handleProductTypeChange}>
                                            <FormControlLabel value="bundle" control={< Radio disabled={selectedBinStatus === 'stored'} size="small" color="secondary" />} label="Bundle" />
                                            <FormControlLabel value="pallet" control={<Radio disabled={selectedBinStatus === 'stored'} size="small" color="secondary" />} label="Pallet" />
                                            <FormControlLabel value="reampallet" control={<Radio disabled={selectedBinStatus === 'stored'} size="small" color="secondary" />} label="Ream Pallet" />
                                        </RadioGroup>
                                    </Grid>

                                </Grid>

                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > Product Code </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>

                                        <Autocomplete
                                            size="small"
                                            disabled={selectedBinStatus === 'stored'}
                                            fullWidth
                                            options={reelList}
                                            value={selectedReel}
                                            onChange={(event, newValue) => {
                                                setSelectedReel(newValue);
                                                // setSelectedPartyID(newValue.id);
                                                // Add a null check before accessing newValue.id
                                                if (newValue) {
                                                    handleGetReelDetails(newValue.id);
                                                } else {
                                                    // Handle the case where newValue is null (e.g., clear the details)
                                                    handleClearReelDetails(); // Implement this function as needed
                                                }
                                            }}
                                            getOptionLabel={(option) => option.description || ''}
                                            renderInput={(params) => (
                                                <TextField {...params} label="" required variant="outlined" />
                                            )}
                                        />
                                    </Grid>

                                </Grid>


                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > Quality</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            value={quality}
                                            size="small"
                                            variant="outlined"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > GSM</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            value={gsm}
                                            size="small"
                                            variant="outlined"
                                            required
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > Size</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            value={size}
                                            size="small"
                                            variant="outlined"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > Total Weight</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            value={weight}
                                            size="small"
                                            variant="outlined"
                                            required
                                        />
                                    </Grid>
                                </Grid>


                            </Grid>

                        </Grid>
                        <Divider sx={{ marginTop: '10px' }} />
                        {selectedBinStatus === 'open' && (
                            <Button onClick={StoreReelToWarehouse} size="small" variant="contained" color="secondary" sx={{ marginTop: '10px', marginLeft: '10px' }}>Save</Button>
                        )}
                    </Box>
                </>

            )}

            {/* transfer stock one location to another location */}


            {transferStock && (
                <>

                    <Header title={selectedBinStatus === 'stored' ? 'Transfer Bin Stock To New Location' : 'Bin Allocation for Bundles & Pallets'} subtitle="" callback={callback} />
                    <Divider />

                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        <Grid container  >
                            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontWeight="bold"> Current Location Code </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            size="small"
                                            // label="Zone"
                                            variant="outlined"
                                            value={locationCode}
                                            // onChange={(e) => setZone(e.target.value)}
                                            required
                                        />
                                    </Grid>
                                </Grid>



                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > Product Code </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>

                                        <Autocomplete
                                            size="small"
                                            disabled={selectedBinStatus === 'stored'}
                                            fullWidth
                                            options={reelList}
                                            value={selectedReel}
                                            onChange={(event, newValue) => {
                                                setSelectedReel(newValue);
                                                // setSelectedPartyID(newValue.id);
                                                handleGetReelDetails(newValue.id);
                                            }}
                                            getOptionLabel={(option) => option.description || ''}
                                            renderInput={(params) => (
                                                <TextField {...params} label="" required variant="outlined" />
                                            )}
                                        />
                                    </Grid>

                                </Grid>


                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontWeight="bold"> Warehouse Name </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>
                                        <CustomAutocomplete
                                            label="Warehouse"
                                            options={paymentTerms}
                                            selectedOption={selectedPaymentTerm}
                                            setSelectedOption={setSelectedPaymentTerm}
                                            setAnchorEl={setPaymentTermAnchorEl}
                                            anchorEl={paymentTermAnchorEl}
                                            handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                                            handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                                            filterText={paymentTermFilterText}
                                            setFilterText={setPaymentTermFilterText}
                                            handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                                            handleAddOption={handleAddOption('Warehouse')}
                                            selectedID={paymentTermsID}
                                            setSelectedID={setPaymentTermsID}
                                            isRequired={true}
                                        />
                                    </Grid>

                                </Grid>


                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" > New Location </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>

                                        <Autocomplete
                                            size="small"

                                            fullWidth
                                            options={slotList}
                                            value={selectedLocation}
                                            onChange={(event, newValue) => {
                                                setSelectedLocation(newValue);
                                                // setSelectedPartyID(newValue.id);
                                                // handleGetReelDetails(newValue.id);
                                            }}
                                            getOptionLabel={(option) => option.location_code || ''}
                                            renderInput={(params) => (
                                                <TextField {...params} label="" required variant="outlined" />
                                            )}
                                        />
                                    </Grid>

                                </Grid>




                            </Grid>

                        </Grid>
                        <Divider sx={{ marginTop: '10px' }} />
                        <Button onClick={callTransferData} size="small" variant="contained" color="secondary" sx={{ marginTop: '10px', marginLeft: '10px' }}>Transfer Stock</Button>
                    </Box>
                </>
            )}



        </Box>
    );
}
export default LoadBinStorageDetails;